import { useEffect } from "react";
import { ContainerV2, H1, P, SelectableOptionCardV2 } from "../../Atoms";
import { OpcoesServicosEnum } from "../../../enums/opcoesServicos";
import { Tracking } from "../../../services/Tracking";
import { useServicesV2 } from "./useServicesV2";

export const ServicesV2 = () => {
  const {
    stepIndicator,
    servicoSelecionado,
    isLoteAgendamento,
    handleSelect,
    handleAvancar,
  } = useServicesV2();

  useEffect(() => {
    const pageviewEvent = isLoteAgendamento
      ? "mapa:agendamento-lote/servicos:pageview"
      : "mapa:agendamento/servicos:pageview";
    Tracking.pageView(pageviewEvent);
  });

  return (
    <ContainerV2
      nextButton={{
        title: "Avançar",
        disabled: !servicoSelecionado,
        onClick: handleAvancar,
      }}
    >
      {stepIndicator}
      <H1 className="mb-4 mt-8">Qual tipo de serviço você precisa?</H1>
      <P className="mb-6 text-[#666666]">
        Selecione uma das opções de serviço.
      </P>

      <div className="flex flex-col gap-2.5">
        <SelectableOptionCardV2
          icon={<img src="/assets/svgs/icon-compare-arrows.svg" alt="" />}
          title="Transferência de propriedade"
          description="Veículo mudando de proprietário"
          selected={servicoSelecionado === OpcoesServicosEnum.VISTORIA}
          onSelect={() => handleSelect(OpcoesServicosEnum.VISTORIA)}
        />
        <SelectableOptionCardV2
          icon={<img src="/assets/svgs/icon-new-vehicle.svg" alt="" />}
          title="Primeiro emplacamento"
          description="Veículo novo, sem placa anterior"
          selected={servicoSelecionado === OpcoesServicosEnum.EMPLACAMENTO}
          onSelect={() => handleSelect(OpcoesServicosEnum.EMPLACAMENTO)}
        />
        {!isLoteAgendamento && (
          <SelectableOptionCardV2
            icon={<img src="/assets/svgs/icon-task.svg" alt="" />}
            title="Primeiro registro"
            description="Primeiro registro no DETRAN"
            selected={
              servicoSelecionado === OpcoesServicosEnum.PRIMEIRO_REGISTRO
            }
            onSelect={() => handleSelect(OpcoesServicosEnum.PRIMEIRO_REGISTRO)}
          />
        )}
      </div>
    </ContainerV2>
  );
};
